<template>
  <div class="row vp" >
    <div class="col-lg-12 p-0 bg-white border-right" >
      <ag-grid-vue style="width: 100%; height: calc(100vh - 48px);"
        class="ag-theme-balham" 
        :columnDefs="columnDefs"
        :floatingFilter="true"
        :modules="modules"
        @rowDoubleClicked="rowClicked"
        :sideBar="sideBar"
        :suppressCellSelection="true"
        :rowData="rowData">
      </ag-grid-vue>
    </div>
  </div> 
</template>

<script>
import api from '@/api.js'
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import {
  AgGridVue
} from 'ag-grid-vue'



export default {

  components: {
    AgGridVue
  },

  data() {
    return {
      loading: false,
      rowData: [],
      columnDefs: [],
      modules: null,
      sideBar: null,
    }
  },
  beforeMount() {
    this.columnDefs = [{
        headerName: 'Number',
        field: 'number',
        sortable: true,
        width: 100,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Client',
        field: 'client.nickname',
        sortable: true,
        filter: 'agTextColumnFilter',
        enableRowGroup: true
      },
      {
        headerName: 'PO Number',
        field: 'po_number',
        sortable: true,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Container Number',
        field: 'container_number',
        sortable: true,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Appointment',
        field: 'appt_at',
        sortable: true,
        filter: 'agDateColumnFilter'
      },
      {
        headerName: 'Status',
        field: 'status.name',
        sortable: true,
        filter: true,
        width: 150,
        enableRowGroup: true,
        cellStyle: function(params) {
          return { color: '#fff', backgroundColor: params.data.status.color }
        }
      },
    ]

    this.sideBar = {
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel"
        },
        {
          id: "filters",
          labelDefault: "Filters",
          labelKey: "filters",
          iconKey: "filter",
          toolPanel: "agFiltersToolPanel"
        }
      ],
      defaultToolPanel: "filters",
      hiddenByDefault: true
    }

    api.get('/inbound-orders').then(res => {
      this.rowData = res.data.orders
    })
  },

  methods: {
    rowClicked(event) {
      this.$router.push(`/inbound/${event.data.id}`)
    },

    goToInbound(params) {
      this.$router.push(`/inbound/${params.row.id}`)
    }
  },
}

</script> 

<style scoped >
  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 48px);
  }

  .vp {
    height: calc(100vh - 48px);
  } 
  </style>
